// extracted by mini-css-extract-plugin
module.exports = {"root":"tile_root__vfsTX flex items-center justify-center relative","root_active":"tile_root_active__E2ub7 tile_root__vfsTX flex items-center justify-center relative"};